import { Box, Flex, SimpleGrid, Spinner } from "@chakra-ui/react";
import { CardUI } from "../../components/CardUI";
import { SelectRegionButton } from "../../components/SelectRegionButton";
import { GetPokemons } from "../../hooks/get-pokemons";
import { SelectRegion } from "../../hooks/select-region";
import { Lang } from "../../hooks/lang";

export const Index = () => {
  const { t: t } = Lang();
  const { isLoading: isLoading, pokemons: pokemons } = GetPokemons();
  const { range, setRange } = SelectRegion();

  const gridItems = pokemons.slice(range[0], range[1]).map((pokemon) => {
    return (
      <CardUI
        key={pokemon.id}
        id={pokemon.id}
        imageUrl={pokemon.sprites.front_default}
        name={t("pokemon_name." + pokemon.name)}
      />
    );
  });

  return (
    <Box>
      <Flex justifyContent={"flex-start"}>
        <SelectRegionButton
          region={t("region.kanto")}
          handleClick={() => {
            setRange([0, 151]);
          }}
        />
        <SelectRegionButton
          region={t("region.johto")}
          handleClick={() => {
            setRange([151, 251]);
          }}
        />
        <SelectRegionButton
          region={t("region.hoenn")}
          handleClick={() => {
            setRange([251, 386]);
          }}
        />
        <SelectRegionButton
          region={t("region.sinnoh")}
          handleClick={() => {
            setRange([386, 493]);
          }}
        />
        <SelectRegionButton
          region={t("region.reset")}
          handleClick={() => {
            setRange([0, 493]);
          }}
        />
      </Flex>

      {isLoading ? (
        <Spinner />
      ) : (
        <SimpleGrid columns={10}>{gridItems}</SimpleGrid>
      )}
    </Box>
  );
};
